module.exports = __webpack_public_path__ + "img/m-t6.b8ae1e66.png";